import { Vec3, Vec2, UITransform, Component, Node } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Vec3 {
        toVec2(out?: Vec2): Vec2;
        toLocal(target: Node | UITransform | Component, out?: Vec3): Vec3;
        toWorld(target: Node | UITransform | Component, out?: Vec3): Vec3;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Vec2 {
        toVec3(out?: Vec3): Vec3;
        toLocal(target: Node | UITransform | Component, out?: Vec3): Vec3;
        toWorld(target: Node | UITransform | Component, out?: Vec3): Vec3;
    }
}

Vec3.prototype.toVec2 = function toVec2(this: Vec3, out?: Vec2) {
    out ??= new Vec2();
    out.set(this.x, this.y);
    return out;
};

Vec3.prototype.toLocal = function toLocal(this: Vec3, target: Node | UITransform | Component, out?: Vec3) {
    if (target instanceof UITransform) {
        return target.convertToNodeSpaceAR(this, out);
    }
    if (target instanceof Component) {
        return target.node.transform.convertToNodeSpaceAR(this, out);
    }
    if (target instanceof Node) {
        return target.transform.convertToNodeSpaceAR(this, out);
    }
    // unknown type
    return out ?? new Vec3();
};

Vec3.prototype.toWorld = function toWorld(this: Vec3, target: Node | UITransform | Component, out?: Vec3) {
    if (target instanceof UITransform) {
        return target.convertToWorldSpaceAR(this, out);
    }
    if (target instanceof Component) {
        return target.node.transform.convertToWorldSpaceAR(this, out);
    }
    if (target instanceof Node) {
        return target.transform.convertToWorldSpaceAR(this, out);
    }
    // unknown type
    return out ?? new Vec3();
};

Vec2.prototype.toVec3 = function toVec3(this: Vec2, out?: Vec3) {
    out ??= new Vec3();
    out.set(this.x, this.y, 0);
    return out;
};

Vec2.prototype.toLocal = function toLocal(this: Vec2, target: Node | UITransform | Component, out?: Vec3) {
    if (target instanceof UITransform) {
        return target.convertToNodeSpaceAR(this.toVec3(), out);
    }
    if (target instanceof Component) {
        return target.node.transform.convertToNodeSpaceAR(this.toVec3(), out);
    }
    if (target instanceof Node) {
        return target.transform.convertToNodeSpaceAR(this.toVec3(), out);
    }
    // unknown type
    return out ?? new Vec3();
};

Vec2.prototype.toWorld = function toWorld(this: Vec2, target: Node | UITransform | Component, out?: Vec3) {
    if (target instanceof UITransform) {
        return target.convertToWorldSpaceAR(this.toVec3(), out);
    }
    if (target instanceof Component) {
        return target.node.transform.convertToWorldSpaceAR(this.toVec3(), out);
    }
    if (target instanceof Node) {
        return target.transform.convertToWorldSpaceAR(this.toVec3(), out);
    }
    // unknown type
    return out ?? new Vec3();
};
